export const BaseFrequencyRange = { min: 400, max: 480, default: 440.0 };
